import React from "react";


const ArrowIcon: React.FC<SoundIconProps> = ({
  size = 20,
  color = "#6D6D70",
  title,
  className,
  ...props
}) => {
  const ariaProps = title
    ? { role: "img" as const, "aria-label": title }
    : { "aria-hidden": true };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...ariaProps}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M9.16699 2.5L8.61486 2.69487C6.46588 3.45333 5.3914 3.83256 4.77919 4.69785C4.16699 5.56313 4.16699 6.70258 4.16699 8.98147V11.0185C4.16699 13.2974 4.16699 14.4369 4.77919 15.3022C5.3914 16.1674 6.46588 16.5467 8.61486 17.3051L9.16699 17.5"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M17.5003 9.99935L9.16699 9.99935M17.5003 9.99935C17.5003 9.41583 15.8384 8.32562 15.417 7.91602M17.5003 9.99935C17.5003 10.5829 15.8384 11.6731 15.417 12.0827"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowIcon;
